import { useEffect, useRef } from 'react';
import { useAuth } from 'src/hooks/auth';

export default function Logout() {
  const started = useRef(false);
  const { logout } = useAuth();

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    logout();
  }, [logout]);

  return null;
}
